import isString from 'lodash/isString';
import identity from 'lodash/identity';
import uniqueId from 'lodash/uniqueId';
import SimpleTmpl from '@Services/SimpleTmpl';
import RequestUrls from '@Constants/RequestUrlsConstants';
import MessageBroker from '@Services/MessageBroker';
import { RxSocketRequest } from '@Services/Common/RxSocketRequest';
import { dispatchOpenBatchModal } from '@Containers/Search/Shared/BatchFile/BatchModalActions';
import { BATCH_FILE } from '@Services/BatchSearchRunner/constants';

const { format, formatOptional } = SimpleTmpl;

const { parser } = BATCH_FILE;

/**
 * Parse batch file
 * @param file
 * @returns {*} Promise
 */
export const parseFile = (file) => {
  if (!file) {
    return Promise.reject(new Error('File is undefined.'));
  }

  const queryId = uniqueId('batch-file');
  const url = formatOptional(RequestUrls.searchBatchFile.url, { queryId });

  const requestData = new FormData();
  requestData.append('file', file);

  return MessageBroker.send({ url, method: RequestUrls.searchBatchFile.method }, requestData, {
    transformRequest: identity,
    headers: { 'Content-Type': undefined },
  })
    .then((fileName) => {
      if (!isString(fileName) || !fileName) {
        return Promise.reject(new Error('Unknown error'));
      }
      return RxSocketRequest({
        data: {},
        in: format(parser.in, { queryId }),
        out: format(parser.out, { queryId }),
        filter: ({ payload }) => payload.queryId === queryId,
      })
        .then(({ payload }) => payload)
        .catch(Logger.reject);
    })
    .catch(Logger.reject);
};

/**
 * Show Batch File
 * @param batchFile
 * @returns {boolean}
 */
export const showBatchFile = (batchFile) => {
  dispatchOpenBatchModal(batchFile);
};
